import React from 'react';
import { Logo } from 'components/UI/logo/logo';
import styles from '../_auth.module.scss';

const AuthFooter: React.FC = () => {
  return (
    <div className={styles.Footer}>
      <div className={styles.FooterBody}>
        <Logo />
        <div className={styles.FooterLinks}>
          <a href={import.meta.env.VITE_DOMAIN_BASE.replace('/api', '') + '/support'}>Contact Us</a>
          <a href="https://reflectography.com/terms-of-service">Terms of Service</a>
          <a href="https://reflectography.com/privacy-policy">Privacy Policy</a>
        </div>
      </div>
      <div className={styles.FooterCopyright}>
        <p>© {new Date().getFullYear()} Reflectography Pulse. All rights reserved.</p>
      </div>
    </div>
  );
};

export { AuthFooter };
